import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";

import ModalImage from "react-modal-image";
import api from "../../services/api";

const useStyles = makeStyles(theme => ({
	// Só o arredondamento: largura e altura ficam por conta da moldura, que
	// distingue miniatura de tela cheia. Antes esta classe forçava 250x200 e
	// era passada para o componente inteiro.
	messageMedia: {
		borderRadius: 8,
	},







	moldura: {
		width: 250,
		overflow: "hidden",
		borderRadius: 8,
		backgroundColor: "rgba(0, 0, 0, 0.05)",
		display: "block",
		lineHeight: 0,

		// ATENCAO: o "& img" solto que existia aqui era o bug do visualizador.
		// O react-modal-image renderiza a tela cheia DENTRO deste mesmo div, e a
		// imagem ampliada herdava width:100% + maxHeight:340 + objectFit:cover --
		// ou seja, era esticada na largura da tela e cortada em cima e embaixo.
		//
		// "& > img" resolve: FILHO DIRETO. A miniatura e filha direta da moldura; a tela
		// cheia vem dentro de uma <div>, entao nao e atingida. Nao depende do nome
		// das classes da biblioteca, que podem mudar de versao.
		"& > img": {
			width: "100%",
			height: "auto",
			maxHeight: 340,
			objectFit: "cover",
			display: "block",
			cursor: "pointer",
			margin: 0,
		},

		// A tela cheia e position:fixed, entao precisa das proprias medidas.
		// contain (e nao cover) para mostrar a foto inteira, sem cortar.
		// Qualquer imagem dentro de uma div filha = o visualizador em tela cheia.
		"& div": {
			lineHeight: "normal",

			"& img": {
				width: "auto !important",
				height: "auto !important",
				maxWidth: "92vw",
				maxHeight: "88vh",
				objectFit: "contain",
				margin: "auto",
				cursor: "default",
			},
		},
	},
}));

const ModalImageCors = ({ imageUrl }) => {
	const classes = useStyles();
	const [fetching, setFetching] = useState(true);
	const [blobUrl, setBlobUrl] = useState("");

	useEffect(() => {
		if (!imageUrl) return;
		const fetchImage = async () => {
			const { data, headers } = await api.get(imageUrl, {
				responseType: "blob",
			});
			const url = window.URL.createObjectURL(
				new Blob([data], { type: headers["content-type"] })
			);
			setBlobUrl(url);
			setFetching(false);
		};
		fetchImage();
	}, [imageUrl]);

	return (
		<div className={classes.moldura}>
			<ModalImage
				className={classes.messageMedia}
				smallSrcSet={fetching ? imageUrl : blobUrl}
				medium={fetching ? imageUrl : blobUrl}
				large={fetching ? imageUrl : blobUrl}
				alt="image"
			/>
		</div>
	);
};

export default ModalImageCors;
